import React from 'react';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 py-12">
      <div className="max-w-5xl mx-auto px-4">
        <header className="mb-12">
          <h1 className="text-4xl font-display font-bold text-primary-900 dark:text-primary-300 mb-4">Politique de confidentialité</h1>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl">Cette politique explique quelles données nous collectons, comment nous les utilisons et vos droits en tant qu'utilisateur.</p>
        </header>

        <div className="space-y-10">
          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Données collectées</h2>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
              <li>Informations de compte (nom, email, téléphone, région, spécialité artisan).</li>
              <li>Données de navigation (pages consultées, produits favoris) sous forme agrégée.</li>
              <li>Photos et descriptions fournies par les artisans pour leurs profils et produits.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Finalités</h2>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
              <li>Fournir et améliorer la Plateforme et les services associés.</li>
              <li>Assurer l'authentification, la sécurité et la prévention des fraudes.</li>
              <li>Envoyer des notifications liées au compte (changements, confirmations).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Partage des données</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Nous ne vendons pas vos données. Elles peuvent être partagées avec des prestataires techniques (hébergement, stockage) strictement nécessaires au fonctionnement et soumis à confidentialité.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Cookies</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Des cookies techniques et de mesure d'audience peuvent être utilisés pour sécuriser les sessions et améliorer l'expérience. Vous pouvez configurer votre navigateur pour les limiter.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Durée de conservation</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Les données sont conservées le temps strictement nécessaire aux finalités décrites ci-dessus, puis supprimées ou anonymisées.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Vos droits</h2>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
              <li>Droit d'accès, de rectification et d'effacement.</li>
              <li>Droit d'opposition et de limitation du traitement.</li>
              <li>Droit à la portabilité des données (sur demande).</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 mt-2">Pour exercer vos droits : <a href="mailto:privacy@villageartisanal.sn" className="text-accent-600 dark:text-accent-400 hover:underline">privacy@villageartisanal.sn</a></p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Mise à jour</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Dernière mise à jour : {new Date().toLocaleDateString()}. Nous pouvons modifier cette politique pour refléter les évolutions légales et techniques.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
